export default "__VITE_ASSET__1e1dc885__"